import Amplify from "aws-amplify"

export const getLatestJwtToken = async (): Promise<string> => {
  const session = await Amplify.Auth.currentSession();
  return session.getAccessToken().getJwtToken();
}

export const getLoggedInUserName = async (): Promise<string> => {
  const user = await Amplify.Auth.currentUserInfo();
  return user?.username;
}
